import(/* webpackMode: "eager", webpackExports: ["TextToMusicProgressProvider"] */ "C:\\var\\coverz_ui\\src\\components\\pages\\text-to-music\\components\\providers\\text-to-music-progress-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\var\\coverz_ui\\src\\components\\pages\\text-to-music\\components\\providers\\text-to-music-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\var\\coverz_ui\\src\\components\\pages\\text-to-music\\text-to-music-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\var\\coverz_ui\\src\\hooks\\providers\\wavesurfer-provider.tsx");
